String.prototype.isNumber = function () {
    return /^\d+$/.test(this);
}
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
window.makeid = function (length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

String.prototype.camelize = function () {
    let str = this.toLowerCase()
        .trim()
        .split(/[ -_]/g)
        .map(word => word.replace(word[0], word[0].toString().toUpperCase()))
        .join('');

    return str.replace(str[0], str[0].toLowerCase());
}

Array.prototype.inColumns = function (parts) {
    const result = [];
    const chunkSize = Math.ceil(this.length / parts);

    for (let i = 0; i < parts; i++) {
        const start = i * chunkSize;
        const end = start + chunkSize;
        result.push(this.slice(start, end));
    }

    return result;
}

/**
 * Явно заданная функция для капитализации в обход прототипов, тк тскомпайлер не очень дружит с такой магией
 * @param stringEntry
 * @returns {string|*}
 */
export const capitalize = (stringEntry) => (typeof stringEntry === 'string')
    ? stringEntry.charAt(0).toUpperCase() + stringEntry.slice(1)
    : stringEntry;